import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { FormState } from '../pages/BorrowerForm';

interface ConditionItem {
  key: string;
  label: string;
}

interface ConditionsAccordionProps {
  formState: FormState;
  expanded: boolean;
  onChange: () => void;
  handleConditionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  conditionItems: ConditionItem[];
}

const ConditionsAccordion: React.FC<ConditionsAccordionProps> = ({
  formState,
  expanded,
  onChange,
  handleConditionChange,
  conditionItems
}) => {
  return (
    <Accordion 
      expanded={expanded}
      onChange={onChange}
      sx={{ mb: 0.5, backgroundColor: 'rgba(240, 245, 250, 0.9)' }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="conditions-content"
        id="conditions-header"
        sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', minHeight: '42px', '& .MuiAccordionSummary-content': { margin: '8px 0' } }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 0 }} fontSize="1.1rem">
          Conditions
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 1, pb: 0.5 }}>
        <Grid container spacing={0.5}> 
          {conditionItems.map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item.key}> 
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formState.conditions[item.key] || false}
                    onChange={handleConditionChange}
                    name={item.key}
                    size="small"
                  />
                }
                label={item.label}
                sx={{ '& .MuiTypography-root': { fontSize: '0.875rem' } }} 
              />
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ConditionsAccordion;
